import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT_API_TOKEN } from '@campus/environment';
import { Observable } from 'rxjs';
import { LinguineoConversationDetail } from '../interfaces';

@Injectable({ providedIn: 'root' })
export class ConversationReviewService {
  private http = inject(HttpClient);
  private envApi = inject(ENVIRONMENT_API_TOKEN);

  getConversationDetail$(resultId: number): Observable<LinguineoConversationDetail> {
    return this.http.get<LinguineoConversationDetail>(
      `${this.envApi.APIBase}/api/Linguineo/results/${resultId}/conversation`
    );
  }
}
